<div
  class="flex flex-col sm:flex-row items-center justify-between gap-4 p-3 bg-card-light dark:bg-card-dark rounded-xl shadow-sm border border-gray-200 dark:border-gray-700"
>
  <!-- Left: Items per page dropdown -->
  <div class="flex items-center gap-2 text-sm text-subtext-light dark:text-subtext-dark">
    <label for="limitSelect" class="font-medium">Items per page:</label>
    <select
      id="limitSelect"
      [value]="limit"
      (change)="onLimitChange($event)"
      class="bg-background-light dark:bg-background-dark border border-gray-300 dark:border-gray-600 rounded-lg px-2 py-1 text-sm focus:ring-2 focus:ring-primary focus:outline-none"
    >
      <option *ngFor="let option of limitOptions" [value]="option">{{ option }}</option>
    </select>
  </div>

  <!-- Right: Page navigation -->
  <nav class="flex items-center gap-2">
    <!-- Previous -->
    <button
      class="flex items-center justify-center size-9 rounded-lg hover:bg-primary/10 transition disabled:opacity-40"
      [disabled]="currentPage === 1"
      (click)="onPageChange(currentPage - 1)"
    >
      <span class="material-symbols-outlined text-lg">chevron_left</span>
    </button>

    <!-- Page Numbers -->
    <button
      *ngFor="let page of pages"
      (click)="onPageChange(page)"
      class="flex items-center justify-center size-9 rounded-lg font-medium text-sm transition"
      [ngClass]="{
        'bg-primary/20 text-primary font-semibold': page === currentPage,
        'hover:bg-primary/10 text-subtext-light dark:text-subtext-dark': page !== currentPage
      }"
    >
      {{ page }}
    </button>

    <!-- Next -->
    <button
      class="flex items-center justify-center size-9 rounded-lg hover:bg-primary/10 transition disabled:opacity-40"
      [disabled]="currentPage === totalPages"
      (click)="onPageChange(currentPage + 1)"
    >
      <span class="material-symbols-outlined text-lg">chevron_right</span>
    </button>
  </nav>
</div>
